import React from 'react';
import { Lock, MessageCircle } from 'lucide-react';
import { Button } from './ui';

interface FeatureLockedProps {
  title?: string;
  message?: string;
  showBackButton?: boolean;
  showContactButton?: boolean;
}

const FeatureLocked: React.FC<FeatureLockedProps> = ({
  title = 'Feature Upgrade Available!',
  message = 'This feature is part of our premium plan. Contact your administrator to unlock this powerful tool!',
  showBackButton = true,
  showContactButton = true,
}) => {
  const handleBack = () => {
    window.history.back();
  };

  const handleContact = () => {
    console.log('Contact support for feature upgrade');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          {/* Icon */}
          <div className="mx-auto w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-6 shadow-lg">
            <Lock className="w-12 h-12 text-blue-600" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-800 mb-4">{title}</h1>

          {/* Message */}
          <p className="text-gray-600 leading-relaxed mb-8 text-lg">
            {message}
          </p>
        </div>



        {/* Action Buttons */}
        <div className="space-y-4">
          {showContactButton && (
            <Button
              onClick={handleContact}
              variant="primary"
              className="w-full"
              startIcon={<MessageCircle size={18} />}
            >
              Contact Support to Upgrade
            </Button>
          )}

          {showBackButton && (
            <Button
              onClick={handleBack}
              variant="outline"
              className="w-full"
            >
              Go Back
            </Button>
          )}
        </div>

        {/* Help Text */}
        <div className="mt-8 pt-6 border-t border-blue-100">
          <p className="text-sm text-gray-600">
            🤝 Your school's WhatsApp support team can help you upgrade your plan to unlock this feature!
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeatureLocked;
